export function getApiUrl(path: string = ''): string {
    const base = import.meta.env.VITE_API_URL;

    return base + path;
}

export function getSignInUrl(withReturnUrl: boolean, returnUrl?: string): string {
    const accountAppUrl = import.meta.env.VITE_ACCOUNT_APP_URL;

    if (withReturnUrl) {
        const target = returnUrl ?? window.location.href;
        return `${accountAppUrl}/login?returnUrl=${encodeURIComponent(target)}`;
    }
    return `${accountAppUrl}/login`;
}
